import React__default from 'react';
import { useBreakpointValue } from './useBreakpointValue.js';
var useMediaQuery = function useMediaQuery() {
  var value = useBreakpointValue([0, 1, 2]);
  return React__default.useMemo(function () {
    if (value === 0) {
      return {
        isMobile: true,
        isTablet: false,
        isDesktop: false
      };
    }
    if (value === 1) {
      return {
        isMobile: false,
        isTablet: true,
        isDesktop: false
      };
    }
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: true
    };
  }, [value]);
};
export { useMediaQuery };